module.exports = __webpack_public_path__ + "static/media/opera.d95ccd6b.svg";